import { dealConstants } from "../constants/dealConstants";

const initialState = {
  sending: false,
  dealList: {},
  dealPendingList: {},
  dealUpcomingList: {},
  dealPastList: {},
  dealDeleted: {},
  dealDetail: {},
  editDeal: {},
  dealLoc: {},
  dealCities: {},
  dealLocationDeleted: {},
  error: {},
  destroyImage: {},
  orderData:{},
  orderSaveData:{},
  closeStatus:{},
  voucherStatus:{},
  getVoucher:{},
  attributeStatus: {},
  imageStatus: {},
  dealScheduleList:{},
  quantityStatus: {},
};

export default function dealReducer(state = initialState, action) {
  switch (action.type) {
    case dealConstants.GET_DEALCURRENT_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALCURRENT_SUCCESS:
      return {
        ...state,
        dealList: action.data,
        dealDeleted: {},
        sending: false
      };
    case dealConstants.GET_DEALCURRENT_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.GET_ORDER_DEALS_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_ORDER_DEALS_SUCCESS:
      return {
        dealList: action.dealList,
        orderSaveData: {},
        sending: false
      };
    case dealConstants.GET_ORDER_DEALS_FAILURE:
      return {
        error: action.error,
        sending: false
      };
    case dealConstants.SAVE_ORDER_DEALS_REQUEST:
      return {
        sending: true
      };
    case dealConstants.SAVE_ORDER_DEALS_SUCCESS:
      return {
        orderSaveData: action.data,
        dealList:{},
        sending: false
      };
    case dealConstants.SAVE_ORDER_DEALS_FAILURE:
      return {
        error: action.error,
        sending: false
      };
    case dealConstants.GET_DEALPENDING_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALPENDING_SUCCESS:
      return {
        ...state,
        dealPendingList: action.data,
        dealDeleted: {},
        sending: false
      };
    case dealConstants.GET_DEALPENDING_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.GET_DEALUPCOMING_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALUPCOMING_SUCCESS:
      return {
        ...state,
        dealUpcomingList: action.data,
        dealDeleted: {},
        sending: false
      };
    case dealConstants.GET_DEALUPCOMING_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.GET_DEALPAST_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALPAST_SUCCESS:
      return {
        ...state,
        dealPastList: action.data,
        dealDeleted: {},
        sending: false
      };
    case dealConstants.GET_DEALPAST_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.DELETE_DEAL_REQUEST:
      return {
        sending: true
      };
    case dealConstants.DELETE_DEAL_SUCCESS:
      return {
        ...state,
        dealDeleted: action.data,
        sending: false
      };
    case dealConstants.DELETE_DEAL_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.DELETE_DEAL_LOCATION_REQUEST:
      return {
        sending: true
      };
    case dealConstants.DELETE_DEAL_LOCATION_SUCCESS:
      return {
        ...state,
        dealLocationDeleted: action.data,
        sending: false
      };
    case dealConstants.DELETE_DEAL_LOCATION_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.GET_DEALDETAIL_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALDETAIL_SUCCESS:
      return {
        ...state,
        dealDetail: action.data,
        sending: false
      };
    case dealConstants.GET_DEALDETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.EDIT_DEALLIST_REQUEST:
      return {
        sending: true
      };
    case dealConstants.EDIT_DEALLIST_SUCCESS:
      return {
        ...state,
        editDeal: action.data,
        sending: false
      };
    case dealConstants.EDIT_DEALLIST_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.ADD_DEALLOC_REQUEST:
      return {
        sending: true
      };
    case dealConstants.ADD_DEALLOC_SUCCESS:
      return {
        ...state,
        dealLoc: action.data,
        sending: false
      };
    case dealConstants.ADD_DEALLOC_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.GET_DEALCITIES_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALCITIES_SUCCESS:
      return {
        ...state,
        dealCities: action.data,
        sending: false
      };
    case dealConstants.GET_DEALCITIES_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.DELETE_IMAGE_REQUEST:
      return {
        sending: true
      };
    case dealConstants.DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        destroyImage: action.data,
        sending: false
      };
    case dealConstants.DELETE_IMAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.GET_DEALORDER_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALORDER_SUCCESS:
      return {
        ...state,
        orderData: action.data,
        sending: false
      };
    case dealConstants.GET_DEALORDER_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.CONFIRM_CLOSE_REQUEST:
      return {
        sending: true
      };
    case dealConstants.CONFIRM_CLOSE_SUCCESS:
      return {
        ...state,
        closeStatus: action.data,
        sending: false
      };
    case dealConstants.CONFIRM_CLOSE_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.POST_EXTERNAL_REQUEST:
      return {
        sending: true
      };
    case dealConstants.POST_EXTERNAL_SUCCESS:
      return {
        ...state,
        voucherStatus: action.data
      };
    case dealConstants.POST_EXTERNAL_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case dealConstants.POST_UPEXTERNAL_REQUEST:
      return {
        sending: true
      };
    case dealConstants.POST_UPEXTERNAL_SUCCESS:
      return {
        ...state,
        getVoucher: action.data
      };
    case dealConstants.POST_UPEXTERNAL_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case dealConstants.POST_ATTRIBUTE_REQUEST:
      return {
        sending: true
      };
    case dealConstants.POST_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        attributeStatus: action.data
      };
    case dealConstants.POST_ATTRIBUTE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case dealConstants.UPLOAD_IMAGE_REQUEST:
      return {
        sending: true
      };
    case dealConstants.UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        imageStatus: action,
        sending: false
      };
    case dealConstants.UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.GET_DEALSCHEDULE_REQUEST:
      return {
        sending: true
      };
    case dealConstants.GET_DEALSCHEDULE_SUCCESS:
      return {
        ...state,
        dealScheduleList: action.data,
        dealDeleted: {},
        sending: false
      };
    case dealConstants.GET_DEALSCHEDULE_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    case dealConstants.UPDATE_QUANTITY_REQUEST:
      return {
        sending: true
      };
    case dealConstants.UPDATE_QUANTITY_SUCCESS:
      return {
        ...state,
        quantityStatus: action.data,
        sending: false
      };
    case dealConstants.UPDATE_QUANTITY_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/dealReducer.js